module.exports = __webpack_public_path__ + "static/media/package_design_logo.8d9d7ca8.svg";